import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HomeHeroSection.module.css';

const HomeHeroSection = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const btnRef = useRef(null);
  const imgRef = useRef(null);

  const heroImg =
    "/images/15-DSC09363.jpg";

  useEffect(() => {
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.1 };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const els = [
            { el: titleRef.current, delay: 0 },
            { el: subtitleRef.current, delay: 150 },
            { el: btnRef.current, delay: 300 },
            { el: imgRef.current, delay: 200 },
          ];
          els.forEach(({ el, delay }) => {
            if (!el) return;
            setTimeout(() => el.classList.add(styles.visible), delay);
          });
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={styles.hero}>
      <div className={styles.inner}>

        {/* ── Left: content + CTA ── */}
        <div className={styles.content}>
          <h1 ref={titleRef} className={styles.title}>
            Crafted Brew <br /> Curated Experience
          </h1>
          <p ref={subtitleRef} className={styles.subtitle}>
            Pune's Most Immersive Experience <br /> Now In Kharadi
          </p>
          <button
            ref={btnRef}
            className={styles.cta}
            onClick={() => navigate('/reservation')}
          >
            Reserve a Table
          </button>
        </div>

        {/* ── Right: single image ── */}
        <div ref={imgRef} className={styles.imageWrap}>
          <img src={heroImg} alt="Craft beer and plated dish at Berli Brewing Co." />
        </div>

      </div>
    </section>
  );
};

export default HomeHeroSection;